import React, { useEffect } from 'react';
import { get } from 'lodash';
import { Card, Icon, Button, Loader } from 'components';
import { ApplicationFullInformation } from 'control-components';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { useSelect, useAction } from 'hooks';
import ContainerTransactionItem from '../transaction-history/ContainerTransactionItem';

const ViewApplication = () => {
  const { params } = useRouteMatch()
  const history = useHistory()

  const getSelected = useAction('payment.view')
  const selectedPayment = useSelect('payment.selected', { id: params.id })
  
  const selectedApplication = useSelect('application.selected', { id: get(selectedPayment, 'relationships.module.data.id') });
  const selectedOwnershipType = useSelect('ownershipType.selected', { id: get(selectedApplication, 'attributes.ownership_type_id') });
  
  const selectedIndividual =  useSelect('application.selectedIndividual', { id: get(selectedPayment, 'relationships.moduleDetail.data.id') })
  const selectedNonIndividual =  useSelect('application.selectedNonIndividual', { id: get(selectedPayment, 'relationships.moduleDetail.data.id') })
  
  const listExistingFranchise = useSelect('application.selectedExistingFranchisByApplicationId', { application_id: get(selectedApplication, 'id') })
  const listAuthorizedDrivers = useSelect('application.selectedAuthorizedDriversByApplicationId', { application_id: get(selectedApplication, 'id') })
  const listRequirements = useSelect('application.selectedRequirementsArrayByPaymentId', { payment_id: params.id })
  const listServiceUnits = useSelect('application.selectedServiceUnitsByApplicationId', { application_id: get(selectedApplication, 'id') })

  const showing = useSelect('loading.isLoading', { type: 'payment.view' })

  const getModuleDetail = () => {
    if(+get(selectedOwnershipType, 'id') === 1){
      return get(selectedIndividual, 'attributes')
    }
    if([2,3,4].indexOf(+get(selectedOwnershipType, 'id')) > -1){
      return get(selectedNonIndividual, 'attributes') 
    }
  }

  useEffect(() => {
    window.scroll({
      top: 0, 
      left: 0, 
      behavior: 'smooth'
    });
  }, [])

  useEffect(() => {
    getSelected(params.id)
    // eslint-disable-next-line
  }, [])
  
  const handleBack = e => {
    e.preventDefault()
    history.goBack()
  }

  const value = {
    ...getModuleDetail(),
    ...get(selectedApplication, 'attributes'),
    existing_franchises: (get(selectedApplication, 'attributes.servicet_type_name') !== 'TNVS' ? Object.values(listExistingFranchise).map(x => get(x, 'attributes')) : ''),
    authorized_drivers: Object.values(listAuthorizedDrivers).map(x => get(x, 'attributes')),
    application_requirements: Object.values(listRequirements).map(x => get(x, 'attributes')),
    service_units: Object.values(listServiceUnits).map(x => get(x, 'attributes')),
  }

  return (
    <Card className="transaction-history">
        <Card.Header>
          <div className="content space-x-2 flex items-center">
            <Button type="button" onClick={handleBack} className="!w-auto !px-2"><Icon.ChevronLeft /></Button>
            <b className="title font-medium">View Application</b>
          </div>
        </Card.Header>  
        <Card.Body>
          {showing && <Loader.Table />}
          
          {!showing && selectedPayment && 
            <div className="mb-1">
              <ContainerTransactionItem data={selectedPayment}/>
            </div>
          }
          {!showing && <ApplicationFullInformation  
          type={+get(selectedOwnershipType, 'id') === 1 ? 'individual' : 'other'}
          value={value}/>}
        </Card.Body>         
    </Card>
    
  )
}

export default ViewApplication